import React from 'react'
import GetStartedButton from './GetStartedButton'
import TaskList from './TaskList'
import { FormControl, InputLabel, makeStyles, MenuItem, Select, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import defaultTheme from '../../theme/palettes/defaultTheme'
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useGlobalState } from '../../state';
import ProgressCircle from './ProgressCircle'

const useStyles = makeStyles((theme) => ({
  root: props => ({
    width: '100%',
    maxWidth: props.isSmallScreen ? 300 : 360,
    backgroundColor: theme.palette.background.paper,
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    height: props.hasMultipleFarms ? '550px' : '500px',
    maxHeight: '70vh',
    position: 'fixed',
    // sit above the button, which clears the SidebarPro mobile bottom nav (84px + 44px button + 8px gap)
    bottom: props.hasBottomNav ? 'calc(136px + env(safe-area-inset-bottom, 0px))' : theme.spacing(9),
    right: props.isSmallScreen ? theme.spacing(1) : theme.spacing(4),
    zIndex: 100,
  }),
  header: props => ({
    fontWeight: 'bold',
    height: props.hasMultipleFarms ? '120px' : '70px',
    padding: theme.spacing(2),
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    backgroundColor: defaultTheme.primary.secondary,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'column',
    '& h4': {
      color: theme.palette.primary.contrastText,
    },
    '& h6': {
    color: theme.palette.primary.contrastText,
    },
    '& label': {
      color: theme.palette.primary.contrastText,
    },
    '& .MuiSelect-icon': {
      color: theme.palette.primary.contrastText,
    },
    '& div': {
      color: theme.palette.primary.contrastText,
    },
  }),
  headerTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  },
  span: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
  },
  body: props => ({
    overflowY: 'scroll',
    height: '450px',
    maxHeight : `calc(70vh - ${props.hasMultipleFarms ? 120 : 70}px)`, // 70px/120px is the height of the header
  }),
  icon: {
    marginRight: '5px'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    marginBottom: theme.spacing(2),
},
}));

function GetStarted() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [completedTasksCount, setCompletedTasksCount] = React.useState(0)
  const [selectedFarm, setSelectedFarm] = React.useState(undefined);
  const [hasMultipleFarms, setHasMultipleFarms] = React.useState(false);
  const location = useLocation();
  const [{ user }] = useGlobalState();
  
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('xs'), {
    defaultMatches: true
  });
  const hasBottomNav = useMediaQuery(theme.breakpoints.down('md'), {
    defaultMatches: true
  });
  const classes = useStyles({ isSmallScreen, hasBottomNav, hasMultipleFarms });

  React.useEffect(() => {
    if (user && user.onboardingTasks) {
      const completedTasks = user.onboardingTasks.filter(task => task.isCompleted).length;
      setCompletedTasksCount(completedTasks);
    }
  }, [user]);

  // Farm selection logic
  React.useEffect(() => {
    if (user && user.farms) {
      if (user.farms.length > 1) {
        setHasMultipleFarms(true);
      } else if (user.farms.length === 1) {
        setHasMultipleFarms(false);
        setSelectedFarm(user.farms[0].id);
      }
    }
  }, [user]);

  const taskProgressPercentage = (completedTasksCount / (user?.onboardingTasks?.length)) * 100;

  // Hide the component if the current path is '/welcome'
  if (location.pathname === '/welcome') {
    return null;
  }

  const handleClick = () => {
    setIsOpen(!isOpen);
  }

  // Farm select change handler
  const handleFarmChange = (event) => {
    setSelectedFarm(event.target.value);
  }

  return (
    <>
      {user?.Config?.onboarding_tasks && user?.onboardingTasks ? (
        <>
          {isOpen ? (
            <div id='get-started' className={classes.root}>
              <div className={classes.header}>
                <div className={classes.headerTitle}>
                <Typography variant="h4" align="left">Get Started</Typography>
                <span className={classes.span}>
                  <ProgressCircle className={classes.icon} percentage={taskProgressPercentage} />
                  <Typography variant="h6" className={classes.headerProgressText}>{completedTasksCount}/{user.onboardingTasks.length}</Typography>
                </span>
                </div>
                {/* Farm selection: show if user has completed ADD_FARM and has multiple farms */}
                {user.onboardingTasks && user.onboardingTasks.find(t => t.id === 1 && t.isCompleted) && hasMultipleFarms ? (
                  <FormControl className={classes.formControl}>
                    <InputLabel id="get-started-select-label">Select Farm</InputLabel>
                    <Select
                      id="get-started-select"
                      value={selectedFarm !== undefined ? selectedFarm : ''}
                      onChange={handleFarmChange}
                      name="farmIndex"
                    >
                      {user.farms && user.farms.map((farm, farmIndex) => (
                        <MenuItem key={farmIndex} value={farm.id}>{farm.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : null}
              </div>
              <div className={classes.body}>
                <TaskList tasks={user.onboardingTasks} farms={user.farms} setTasksListIsOpen={setIsOpen} selectedFarm={selectedFarm} setSelectedFarm={setSelectedFarm} />
              </div>
            </div>
          ) : null}
          <GetStartedButton
            isOpen={isOpen}
            handleClick={handleClick}
            totalTaskCount={user.onboardingTasks.length}
            completedTasksCount={completedTasksCount}
          />
        </>
      ) : null}
    </>
  )
}

export default GetStarted